import { render } from "./HeroiconsOutlineHand.vue?vue&type=template&id=226c3ff2"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineHand.vue"]])

export default __exports__